package com.vizio.redwolf.auth.model

import kotlinx.serialization.Serializable
import kotlin.js.JsExport


@Serializable
@JsExport
data class CreateWalmartAccountRequestInfo(
    val vzAuthCode: String
)